'use client';

import { c as _c } from "react/compiler-runtime";
import { WebAPISubsidyResult } from '@/globals/webApiTypes/elements/WebAPISubsidy';
import { WebAPISubsidiesPage } from '@/globals/webApiTypes/pages/WebAPISubsidiesPage';
import { Results } from './Results';
import { useSelectedFilters } from '@/sections/filter/useSelectedFilters';
import { filterSubsidyResults } from './filterSubsidyResults';
export const FilteredResults = t0 => {
  const $ = _c(7);
  const {
    results,
    filters,
    regionalSubsidiesPage
  } = t0;
  const [selectedFilters] = useSelectedFilters();
  let t1;
  if ($[0] !== filters || $[1] !== results || $[2] !== selectedFilters) {
    t1 = filterSubsidyResults(results, selectedFilters, filters);
    $[0] = filters;
    $[1] = results;
    $[2] = selectedFilters;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const filteredResults = t1;
  let t2;
  if ($[4] !== filteredResults || $[5] !== regionalSubsidiesPage) {
    t2 = <Results results={filteredResults} regionalSubsidiesPage={regionalSubsidiesPage} />;
    $[4] = filteredResults;
    $[5] = regionalSubsidiesPage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};